// extracted by mini-css-extract-plugin
export var content = "Layout-module--content--DgRZy";
export var wide = "Layout-module--wide--MKpev";